import { useState } from "react";
import { useContract } from "./useContract";

interface MutateOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

export const useUpdateContract = () => {
  const { updateContract } = useContract();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const mutate = async ({ data, id }, options?: MutateOptions) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);
    try {
      const result = await updateContract({ data, id });
      if (result.data) {
        setData(result.data);
        setIsSuccess(true);
        options?.onSuccess?.(result.data);
      } else {
        setError("Не удалось обновить договор");
        options?.onError?.("Не удалось обновить договор");
      }
    } catch (error) {
      options?.onError?.(error);
      setError("Не удалось обновить договор");
    } finally {
      setIsLoading(false);
    }
  };
  return { mutate, isLoading, error, isSuccess, data };
};
